import { combineReducers } from "@reduxjs/toolkit";

import userSlice from "./slices/userSlice";
import adminListSlice from "./slices/adminListSlice";
import themeSlice from "./slices/themeSlice";
import attendanceSlice from "./slices/attendanceSlice";
import commonDropdownSlice from "./slices/commonDropdownSlice";
import organizationSlice from "./slices/organizationSlice";
import applicationSlice from "./slices/applicationSlice";
import personSlice from "./slices/personSlice";
import prospectsSlice from "./slices/prospectsSlice";
import logsSlice from "./slices/logsSlice";
import fileSlice from "./slices/fileSlice";
import leaveSlice from "./slices/leaveSlice";
import payslipSlice from "./slices/payslipSlice";
import remainderSlice from "./slices/remainderSlice";

export const reducers = combineReducers({
    user: userSlice,
    adminLists: adminListSlice,
    attendance: attendanceSlice,
    colorMode: themeSlice,
    common: commonDropdownSlice,
    organization: organizationSlice,
    application: applicationSlice,
    person: personSlice,
    prospects: prospectsSlice,
    logs: logsSlice,
    files: fileSlice,
    leave: leaveSlice,
    payslip: payslipSlice,
    remainder:remainderSlice
})